import moment from "moment";

moment.locale('de')

export function parseBool(value) {
    switch(typeof value) {
        case "boolean":
            return value;
        case "string":
            return value.toLowerCase() === "true";
        default:
            return false;
    }
}

export function formatDate(date, format = 'DD-MM-YYYY, HH:mm') {
    if (!date) return
    let newDate = date;
    if (!newDate.includes('+')) newDate += 'Z'; // for date strings without '+' nor 'Z' (Python 3.9's date serializing doesn't add the Z for UTC)
    return moment(newDate).format(format);
}

export const truncateByWord = (str, maxWords = 10) => {
    const words = str.split(' ');
    if (words.length > maxWords) {
        return words.slice(0, maxWords).join(' ') + '...';
    }
    return str;
}
